(() => {
  const els = document.querySelectorAll('[data-vl-cd]');
  const hs = document.querySelectorAll('[data-vl-cdh]'), ms = document.querySelectorAll('[data-vl-cdm]'), ss = document.querySelectorAll('[data-vl-cds]');
  if (els.length || hs.length) {
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const now = new Date();
      const end = new Date(now); end.setHours(24, 0, 0, 0);
      const s = Math.max(0, Math.floor((end - now) / 1000));
      const h = pad(Math.floor(s / 3600)), m = pad(Math.floor((s % 3600) / 60)), sec = pad(s % 60);
      els.forEach((e) => (e.textContent = h + ':' + m + ':' + sec));
      hs.forEach((e) => (e.textContent = h)); ms.forEach((e) => (e.textContent = m)); ss.forEach((e) => (e.textContent = sec));
    };
    tick(); setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-vl-tabs]').forEach((list) => {
    const tabs = [...list.querySelectorAll('[role=tab]')];
    const select = (t) => {
      tabs.forEach((x) => {
        const on = x === t;
        x.setAttribute('aria-selected', on);
        x.tabIndex = on ? 0 : -1;
        const p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(n); n.focus();
        }
      });
    });
  });
  document.querySelectorAll('[data-vl-ba]').forEach((s) => {
    const r = s.querySelector('input[type=range]');
    const set = () => s.style.setProperty('--pos', r.value + '%');
    r.addEventListener('input', set); set();
  });
  document.querySelectorAll('[data-vl-viewers]').forEach((el) => {
    let n = 18 + Math.floor(Math.random() * 14);
    el.textContent = n;
    setInterval(() => { n = Math.max(9, n + (Math.random() > 0.5 ? 1 : -1)); el.textContent = n; }, 4000);
  });
})();
